import React from 'react'

const Separator = () => {
    return (
        <div className="border-t border-gray-300 my-4"></div>
    )
}

export default Separator